<template>
  <div class="p-8 space-y-8">
    <h1 class="text-2xl font-bold mb-4">ThemedTooltip Examples</h1>
    
    <!-- Basic text tooltip -->
    <div class="space-y-2">
      <h2 class="text-lg font-semibold">Basic Text Tooltip</h2>
      <themed-tooltip text="This is a helpful tooltip">
        <button class="px-4 py-2 bg-blue-500 text-white rounded">Hover me</button>
      </themed-tooltip>
    </div>
    
    <!-- Different placements -->
    <div class="space-y-2">
      <h2 class="text-lg font-semibold">Different Placements</h2>
      <div class="flex gap-4">
        <themed-tooltip text="Top tooltip" placement="top">
          <button class="px-4 py-2 bg-blue-500 text-white rounded">Top</button>
        </themed-tooltip>
        
        <themed-tooltip text="Bottom tooltip" placement="bottom">
          <button class="px-4 py-2 bg-blue-500 text-white rounded">Bottom</button>
        </themed-tooltip>
        
        <themed-tooltip text="Left tooltip" placement="left">
          <button class="px-4 py-2 bg-blue-500 text-white rounded">Left</button>
        </themed-tooltip>
        
        <themed-tooltip text="Right tooltip" placement="right">
          <button class="px-4 py-2 bg-blue-500 text-white rounded">Right</button>
        </themed-tooltip>
      </div>
    </div>
    
    <!-- Rich content tooltip -->
    <div class="space-y-2">
      <h2 class="text-lg font-semibold">Rich Content Tooltip</h2>
      <themed-tooltip placement="right">
        <template #default>
          <button class="px-4 py-2 bg-green-500 text-white rounded">Info</button>
        </template>
        <template #content>
          <div>
            <strong>Important:</strong>
            <p>This action cannot be undone.</p>
            <ul class="list-disc pl-4 mt-2">
              <li>Item 1</li>
              <li>Item 2</li>
            </ul>
          </div>
        </template>
      </themed-tooltip>
    </div>
    
    <!-- Custom configuration -->
    <div class="space-y-2">
      <h2 class="text-lg font-semibold">Custom Configuration</h2>
      <themed-tooltip 
        text="This tooltip has a 500ms delay"
        placement="bottom"
        :show-delay="500"
        :offset="12"
        max-width="400px"
      >
        <button class="px-4 py-2 bg-purple-500 text-white rounded">Delayed Tooltip</button>
      </themed-tooltip>
    </div>
    
    <!-- No arrow -->
    <div class="space-y-2">
      <h2 class="text-lg font-semibold">Without Arrow</h2>
      <themed-tooltip 
        text="This tooltip has no arrow"
        :show-arrow="false"
      >
        <button class="px-4 py-2 bg-red-500 text-white rounded">No Arrow</button>
      </themed-tooltip>
    </div>
    
    <!-- Disabled tooltip -->
    <div class="space-y-2">
      <h2 class="text-lg font-semibold">Disabled Tooltip</h2>
      <themed-tooltip 
        text="This won't show"
        :disabled="true"
      >
        <button class="px-4 py-2 bg-gray-500 text-white rounded">Disabled</button>
      </themed-tooltip>
    </div>
  </div>
</template>

<script>
import ThemedTooltip from './ThemedTooltip.vue';

export default {
  name: 'ThemedTooltipExample',
  components: {
    ThemedTooltip
  }
};
</script>
